export const getAutomationPresentation = (mode) => ({
    automatic: { label: 'Automatic', severity: 'info' },
    human_review: { label: 'Human review', severity: 'danger' },
    human_owned: { label: 'Human owned', severity: 'warning' },
    off: { label: 'Automation off', severity: 'secondary' }
}[mode] || { label: mode || '', severity: 'secondary' });

export const getPendingSendSeconds = (scheduledAt, now = Date.now()) => {
    if (!scheduledAt) return null;
    const timestamp = new Date(scheduledAt).getTime();
    if (Number.isNaN(timestamp)) return null;
    return Math.max(0, Math.ceil((timestamp - now) / 1000));
};

export const shouldShowTakeover = (mode) => mode === 'automatic';

export const requiresHumanFollowupConfirmation = (latestCustomerRequest, responseClaim) => Boolean(
    latestCustomerRequest?._id &&
    responseClaim?.customerTurnId === String(latestCustomerRequest._id) &&
    ['deterministic_bot', 'ai_agent'].includes(responseClaim?.owner) &&
    responseClaim?.completedAt
);

export const getAutomationAction = (mode) => {
    if (mode === 'automatic') return 'takeover';
    if (mode === 'human_review' || mode === 'human_owned') return 'release';
    return null;
};

export const getComplaintAutomationState = (complaint = {}) => {
    const current = complaint?.automationState && typeof complaint.automationState === 'object'
        ? complaint.automationState
        : {};
    const mode = complaint?.raisedBy === 'staff' && (!current.mode || current.mode === 'automatic')
        ? 'off'
        : current.mode || 'automatic';

    return {
        deliveredMessages: 0,
        reservedSendSlots: 0,
        consecutiveAutomatedReplies: 0,
        disclosureSentAt: null,
        pendingJob: null,
        riskLevel: 'none',
        escalationReason: null,
        assignedHuman: null,
        targetTeam: null,
        targetRole: null,
        category: null,
        priority: 'normal',
        reviewSummary: null,
        proposedReply: null,
        lastProcessedCustomerTurn: null,
        lastHumanReplyAt: null,
        lastAutomatedReplyAt: null,
        testLiveEnabled: false,
        testLiveDeliveredMessages: 0,
        testLiveEnabledBy: null,
        testLiveEnabledAt: null,
        testLiveDisabledBy: null,
        testLiveDisabledAt: null,
        responseClaim: null,
        ...current,
        mode,
        reasonCodes: Array.isArray(current.reasonCodes) ? [...current.reasonCodes] : [],
        budgetResetAudit: Array.isArray(current.budgetResetAudit) ? [...current.budgetResetAudit] : []
    };
};

export const getAdminAutomationStatus = (settings = {}) => {
    const configuredEnabled = settings.enabled === true && settings.killSwitch !== true;
    if (settings.effectiveEnabled) {
        if (settings.sendingEnabled && settings.mode === 'live') {
            return { configuredEnabled: true, label: 'Agent live (all tickets)', severity: 'success' };
        }
        if (settings.sendingEnabled) {
            return { configuredEnabled: true, label: 'Agent live (canary)', severity: 'warning' };
        }
        return { configuredEnabled: true, label: 'Agent on (shadow)', severity: 'info' };
    }
    if (configuredEnabled && !settings.environmentEnabled) {
        return {
            configuredEnabled: true,
            label: 'Agent configured, server disabled',
            severity: 'warning'
        };
    }
    return { configuredEnabled: false, label: 'Agent off', severity: 'secondary' };
};

export const getSafeAdminTogglePayload = (settings = {}) => ({
    enabled: !(settings.enabled === true && settings.killSwitch !== true)
});
